import type { InputHTMLAttributes } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export function Input({ label, error, className = '', id, ...props }: InputProps) {
  const inputId = id || label?.toLowerCase().replace(/\s+/g, '-');

  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label htmlFor={inputId} className="text-sm font-medium text-text-primary">
          {label}
        </label>
      )}
      <input
        id={inputId}
        className={`h-9 rounded-md border bg-surface px-3 text-sm text-text-primary
          placeholder:text-text-disabled
          focus:border-border-focus focus:outline-none focus:ring-1 focus:ring-border-focus
          disabled:cursor-not-allowed disabled:opacity-50
          ${error ? 'border-error' : 'border-border'}
          ${className}`}
        {...props}
      />
      {error && <p className="text-xs text-error">{error}</p>}
    </div>
  );
}
